import type { FC } from 'react';
import { useState } from 'react';
interface contactProps {
  contact: any;
}

const Contact: FC<contactProps> = ({ contact }) => {
  const [loadingDelete, setLoadingDelete] = useState(false);

  const [hideItem, setHideItem] = useState(false);

  const deleteContact = async (id: number) => {
    const confirmDelete = window.confirm(
      'Are you sure you want to delete this contact?'
    );
    if (!confirmDelete) {
      return;
    }
    setLoadingDelete(true);
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const storedJWT = localStorage.getItem('jwt');
    user.email &&
      (await fetch(process.env.REACT_APP_API_URL + '/delete-contact.php', {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + storedJWT,
        },
        body: JSON.stringify({
          id: id,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.message === 'success') {
            setHideItem(true);
          } else if (data.error) {
            alert(data.error);
            setLoadingDelete(false);
          } else {
            alert('Failed, try again');
            setLoadingDelete(false);
          }
        })
        .catch((error) => {
          // Handle network or server errors
          console.log('error');
          console.log(error);
          alert(error);
          setLoadingDelete(false);
        }));
  };

  return (
    !hideItem && (
      <div className="grid items-center grid-cols-6 gap-0 border-b border-gray-200 hover:bg-gray-100 min-w-[800px]">
        <div>
          <p className="px-3 py-2 overflow-hidden text-sm overflow-ellipsis">
            {contact.lastname}
          </p>
        </div>
        <div>
          <p className="px-3 py-2 overflow-hidden text-sm overflow-ellipsis">
            {contact.firstname}
          </p>
        </div>
        <div>
          <p className="px-3 py-2 overflow-hidden text-sm overflow-ellipsis">
            {contact.title}
          </p>
        </div>
        <div>
          <p className="px-3 py-2 overflow-hidden text-sm overflow-ellipsis">
            {contact.email}
          </p>
        </div>
        <div>
          <p className="px-3 py-2 overflow-hidden text-sm overflow-ellipsis">
            {contact.phone}
          </p>
        </div>

        <div className="flex justify-end">
          {loadingDelete ? (
            <svg
              className={` w-6 h-6 animate-spin mr-5`}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="#ffffff"
              className={` 
                  p-1 transition-colors    mr-5  bg-opacity-50 rounded-md cursor-pointer w-7 h-7  bg-slate-700 hover:bg-red-700 group-hover:inline-block`}
              onClick={() => deleteContact(contact.ID)}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
              />
            </svg>
          )}
        </div>
      </div>
    )
  );
};
export default Contact;
